export const truncate = (str: string, maximal_length: number): string => {
  if (!str) {
    return '';
  }
  if (str.length <= maximal_length) {
    return str;
  }

  return `${str.substring(0, maximal_length)}...`;
};
